import { useCallback, useEffect, useState } from 'react';
import { GetClientParams, getClients } from '../services/api/clientServices';
import useAppSnackbar from './useAppSnackbar';
import { Client } from '../models/client';

interface UseGetClientsReturnType {
  clients: Client[];
  isLoading: boolean;
  refetch: (filters?: GetClientParams) => void;
}

export function useGetClients(
  params?: GetClientParams
): UseGetClientsReturnType {
  const { onErrorSnackbar } = useAppSnackbar();
  const [clients, setClients] = useState<Client[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchClients = useCallback(
    (parameters?: GetClientParams) => {
      setIsLoading(true);
      getClients(parameters)
        .then((res) => {
          setClients(res.items);
        })
        .catch(onErrorSnackbar)
        .finally(() => {
          setIsLoading(false);
        });
    },
    [getClients, onErrorSnackbar]
  );

  useEffect(() => {
    fetchClients(params);
  }, [fetchClients, params]);

  return { clients, isLoading, refetch: fetchClients };
}
